import styled from 'styled-components'

export const CurrencyOption = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: white;

  img {
    width: 20px;
    height: 20px;
  }
`

export const MemoContainer = styled.div`
  margin-bottom: 8px;
`

export const MemoValue = styled.b`
  color: red;
  margin-left: 8px;
`

export const MemoWarning = styled.p`
  margin-bottom: 16px;
`
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const QRContainer = styled.div`
  margin: 16px 0;
`

export const AddressLabel = styled.div`
  margin-bottom: 8px;
`

export const AddressText = styled.div`
  word-break: break-all;
  margin-bottom: 16px;
`

export const CopyButton = styled.button`
  padding: 0 10px;
  height: 24px;
  background: #3ccea2;
  border-radius: 15px;
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  line-height: 20px;

  &.sent {
    background: #8f4bd0;
  }
`

export const Wrapper = styled.div`
  margin-top: 10px;
`
